function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import NumberUtil from '../util/NumberUtil';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Double from '../../../../java/lang/Double';
import Comparable from '../../../../java/lang/Comparable';
import Cloneable from '../../../../java/lang/Cloneable';
import Comparator from '../../../../java/util/Comparator';
import Serializable from '../../../../java/io/Serializable';
import Assert from '../util/Assert';
var Coordinate = /*#__PURE__*/function () {
  function Coordinate() {
    _classCallCheck(this, Coordinate);
    Coordinate.constructor_.apply(this, arguments);
  }
  return _createClass(Coordinate, [{
    key: "setOrdinate",
    value: function setOrdinate(ordinateIndex, value) {
      switch (ordinateIndex) {
        case Coordinate.X:
          this.x = value;
          break;
        case Coordinate.Y:
          this.y = value;
          break;
        case Coordinate.Z:
          this.z = value;
          break;
        default:
          throw new IllegalArgumentException('Invalid ordinate index: ' + ordinateIndex);
      }
    }
  }, {
    key: "equals2D",
    value: function equals2D() {
      if (arguments.length === 1) {
        var other = arguments[0];
        if (this.x !== other.x) {
          return false;
        }
        if (this.y !== other.y) {
          return false;
        }
        return true;
      } else if (arguments.length === 2) {
        var c = arguments[0];
        var tolerance = arguments[1];
        if (!NumberUtil.equalsWithTolerance(this.x, c.x, tolerance)) {
          return false;
        }
        if (!NumberUtil.equalsWithTolerance(this.y, c.y, tolerance)) {
          return false;
        }
        return true;
      }
    }
  }, {
    key: "getOrdinate",
    value: function getOrdinate(ordinateIndex) {
      switch (ordinateIndex) {
        case Coordinate.X:
          return this.x;
        case Coordinate.Y:
          return this.y;
        case Coordinate.Z:
          return this.z;
      }
      throw new IllegalArgumentException('Invalid ordinate index: ' + ordinateIndex);
    }
  }, {
    key: "equals3D",
    value: function equals3D(other) {
      return this.x === other.x && this.y === other.y && (this.z === other.z || Double.isNaN(this.z) && Double.isNaN(other.z));
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (!(other instanceof Coordinate)) {
        return false;
      }
      return this.equals2D(other);
    }
  }, {
    key: "equalInZ",
    value: function equalInZ(c, tolerance) {
      return NumberUtil.equalsWithTolerance(this.z, c.z, tolerance);
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var other = o;
      if (this.x < other.x) return -1;
      if (this.x > other.x) return 1;
      if (this.y < other.y) return -1;
      if (this.y > other.y) return 1;
      return 0;
    }
  }, {
    key: "clone",
    value: function clone() {
      try {
        var coord = null;
        return coord;
      } catch (e) {
        if (e instanceof CloneNotSupportedException) {
          Assert.shouldNeverReachHere("this shouldn't happen because this class is Cloneable");
          return null;
        } else throw e;
      } finally {}
    }
  }, {
    key: "copy",
    value: function copy() {
      return new Coordinate(this);
    }
  }, {
    key: "toString",
    value: function toString() {
      return '(' + this.x + ', ' + this.y + ', ' + this.z + ')';
    }
  }, {
    key: "distance3D",
    value: function distance3D(c) {
      var dx = this.x - c.x;
      var dy = this.y - c.y;
      var dz = this.z - c.z;
      return Math.sqrt(dx * dx + dy * dy + dz * dz);
    }
  }, {
    key: "distance",
    value: function distance(c) {
      var dx = this.x - c.x;
      var dy = this.y - c.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      var result = 17;
      result = 37 * result + Coordinate.hashCode(this.x);
      result = 37 * result + Coordinate.hashCode(this.y);
      return result;
    }
  }, {
    key: "setCoordinate",
    value: function setCoordinate(other) {
      this.x = other.x;
      this.y = other.y;
      this.z = other.z;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Coordinate;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable, Cloneable, Serializable];
    }
  }], [{
    key: "hashCode",
    value: function hashCode() {
      if (arguments.length === 1 && typeof arguments[0] === 'number') {
        var x = arguments[0];
        var f = Double.doubleToLongBits(x);
        return Math.trunc(f ^ f >>> 32);
      }
    }
  }]);
}();
export { Coordinate as default };
var DimensionalComparator = /*#__PURE__*/function () {
  function DimensionalComparator() {
    _classCallCheck(this, DimensionalComparator);
    DimensionalComparator.constructor_.apply(this, arguments);
  }
  return _createClass(DimensionalComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var c1 = o1;
      var c2 = o2;
      var compX = DimensionalComparator.compare(c1.x, c2.x);
      if (compX !== 0) return compX;
      var compY = DimensionalComparator.compare(c1.y, c2.y);
      if (compY !== 0) return compY;
      if (this._dimensionsToTest <= 2) return 0;
      var compZ = DimensionalComparator.compare(c1.z, c2.z);
      return compZ;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DimensionalComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }], [{
    key: "compare",
    value: function compare(a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      if (Double.isNaN(a)) {
        if (Double.isNaN(b)) return 0;
        return -1;
      }
      if (Double.isNaN(b)) return 1;
      return 0;
    }
  }]);
}();
DimensionalComparator.constructor_ = function () {
  this._dimensionsToTest = 2;
  if (arguments.length === 0) {
    DimensionalComparator.constructor_.call(this, 2);
  } else if (arguments.length === 1) {
    var dimensionsToTest = arguments[0];
    if (dimensionsToTest !== 2 && dimensionsToTest !== 3) throw new IllegalArgumentException('only 2 or 3 dimensions may be specified');
    this._dimensionsToTest = dimensionsToTest;
  }
};
Coordinate.DimensionalComparator = DimensionalComparator;
Coordinate.constructor_ = function () {
  this.x = null;
  this.y = null;
  this.z = null;
  if (arguments.length === 0) {
    Coordinate.constructor_.call(this, 0.0, 0.0);
  } else if (arguments.length === 1) {
    var c = arguments[0];
    Coordinate.constructor_.call(this, c.x, c.y, c.z);
  } else if (arguments.length === 2) {
    var x = arguments[0];
    var y = arguments[1];
    Coordinate.constructor_.call(this, x, y, Coordinate.NULL_ORDINATE);
  } else if (arguments.length === 3) {
    var _x = arguments[0];
    var _y = arguments[1];
    var z = arguments[2];
    this.x = _x;
    this.y = _y;
    this.z = z;
  }
};
Coordinate.serialVersionUID = 6683108902428366910;
Coordinate.NULL_ORDINATE = Double.NaN;
Coordinate.X = 0;
Coordinate.Y = 1;
Coordinate.Z = 2;